/**
 * Borrower-facing summaries of answers Owen receives (non-sensitive only).
 */
import { getLegacyQuestionById } from './owenQuestionRouter';
import { V1_TRIAGE_QUESTIONS } from '../config/v1/triage';
import { isOwenBlockedQuestionId } from '../config/owenPrivacy';

function topicForQuestionId(questionId) {
  const legacy = getLegacyQuestionById(questionId);
  if (legacy?.question) {
    return String(legacy.question).replace(/\?+$/, '').trim();
  }
  const v1 = V1_TRIAGE_QUESTIONS.find((q) => q.id === questionId);
  if (v1?.question) {
    return String(v1.question).replace(/\?+$/, '').trim();
  }
  return 'Your answer';
}

/**
 * @returns {{ topic: string, answer: string } | null}
 */
export function getOwenSeesEntry(questionId, answerLabel) {
  if (!questionId || isOwenBlockedQuestionId(questionId)) return null;
  if (String(questionId).startsWith('__')) return null;

  const answer = String(answerLabel || '').trim();
  if (!answer) return null;

  const topic = topicForQuestionId(questionId);
  const displayAnswer = answer.length > 52 ? `${answer.slice(0, 49)}…` : answer;

  return { topic, answer: displayAnswer };
}

/**
 * @param {Array<{ role: string, questionId?: string, text?: string }>} messages
 * @returns {Array<{ topic: string, answer: string }>}
 */
export function buildOwenSeesFromMessages(messages) {
  const entries = [];
  const seen = new Set();

  (messages || []).forEach((m) => {
    if (m.role !== 'user' || !m.questionId) return;
    const entry = getOwenSeesEntry(m.questionId, m.text);
    if (!entry) return;
    const key = `${entry.topic}|${entry.answer}`;
    if (seen.has(key)) return;
    seen.add(key);
    entries.push(entry);
  });

  return entries;
}
